module.exports = __webpack_public_path__ + "static/media/img_12.95c8adf9.JPG";